<template>
  <div class="no-padding">
    <q-form greedy autofocus @submit="onSubmit">
      <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
        <q-card-section class="no-padding">
          <q-banner class="bg-blue text-white" inline-actions>
            <div>
              <span>{{ action === 'edit' ? 'ویرایش' : 'ثبت طرف معامله جدید' }}</span>
              <span v-if="action==='edit'">({{ customerInfo.Cs_Name }})</span>
              <q-toggle v-model="customerInfo.Archived" label="آرشیو"
                        v-if="action === 'edit'"
                        :false-value="false" :true-value="true" :value="false"/>

            </div>
            <div class="row q-ml-xs" v-if="action==='edit'">
              <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ customerInfo.Cs_Code }}</b><i>)</i>
              </q-badge>
              <q-badge class="q-ml-xs" :color="customerInfo.RemCredit > 0 ? 'red-14' : 'green-14'"><i>
                {{ parseInt(customerInfo.RemCredit) > 0 ? 'بدهکار' : 'بستانکار' }}
                (</i><b dir="ltr">{{ Math.abs(customerInfo.RemCredit) | toCurrency }}</b><i>) ریال</i>
              </q-badge>

            </div>

            <template v-slot:action>
              <q-btn icon="close" flat round dense v-close-popup/>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section class="no-padding">
          <q-rating
              v-if="$store.state.roles.some(v=>['admin','can_set_customer_rate'].includes(v))"
              v-model="Customer_Rate"
              size="2em"
              :max="5"
              icon="star_border"
              icon-selected="star"
              color="orange"
          />
          <q-tabs
              v-model="tab"
              dense
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="justify"
          >
            <q-tab name="select" label="صنف کاری"/>
            <q-tab name="info" label="مشخصات"/>
            <q-tab name="phone" label="اطلاعات تماس"/>
            <q-tab name="comment" label="توضیحات"/>
            <q-tab name="tags" label="برچسب ها"/>

          </q-tabs>
          <q-separator/>
          <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="select" style="height: 400px">
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="customerInfo.Cs_CompanyID"
                  use-input
                  input-debounce="0"
                  label="شرکت"
                  :options="companyListOptions"
                  @filter="filterFnCompany"
                  behavior="dialog"
                  hide-bottom-space
                  option-label="CompName"
                  option-value="CompID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="customerInfo.CsState_ID"
                  use-input
                  @filter="stateFilterFn"
                  input-debounce="0"
                  hide-bottom-space
                  label="استان محل فعالیت"
                  :options="stateListOptions"
                  behavior="dialog"
                  option-label="State_Name"
                  option-value="State_ID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="customerInfo.CsCity_ID"
                  use-input
                  input-debounce="0"
                  hide-bottom-space
                  label="شهر محل فعالیت"
                  :options="options"
                  @filter="filterFn"
                  behavior="dialog"
                  option-label="City_Name"
                  option-value="City_ID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="customerInfo.CsZone_ID"
                  use-input
                  input-debounce="0"
                  label="منطقه"
                  hide-bottom-space
                  :options="zonesOptions"
                  behavior="dialog"
                  option-label="Zone_Name"
                  option-value="Zone_ID"
                  :rules="[requireRole]"
                  @filter="filterFnZone"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="customerInfo.CSKind_ID"
                  use-input
                  hide-bottom-space
                  input-debounce="0"
                  label="صنف کاری"
                  :options="customerKindOptions"
                  @filter="filterFnKind"
                  behavior="dialog"
                  option-label="CSKind_Name"
                  option-value="CSKind_ID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  v-if="$store.state.roles.some(v=>['admin','can_change_of_nature'].includes(v))"
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.CsSpe_ID"
                  input-debounce="0"
                  label="ماهیت"
                  :options="customerSpecOptions"
                  behavior="dialog"
                  option-label="CSKind_Name"
                  option-value="CSKind_ID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>

              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.defaultStore"
                  use-input
                  input-debounce="0"
                  label="انبار پیش فرض تحویل کالا"
                  :options="storeList"
                  behavior="dialog"
                  option-label="StorName"
                  option-value="StoreID"
                  :rules="[requireRole]"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </q-tab-panel>
            <q-tab-panel name="info" style="height: 400px">
              <q-select filled
                        label="پیش عنوان"
                        :options="prefixes"
                        v-model="customerInfo.prefix"
                        option-label="label"
                        option-value="id"
                        map-options
                        hide-bottom-space
              >
                <template v-slot:prepend>
                  <q-icon name="person"/>
                </template>
              </q-select>

              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Cs_FirName"
                  label="نام">
                <template v-slot:prepend>
                  <q-icon name="person"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Cs_FamName"
                  label="نام خانوادگی"
                  :rules="[ val => val && val.length > 0 || 'نام خانوادگی الزامی است']">
                <template v-slot:prepend>
                  <q-icon name="person"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Cs_ShopName"
                  :label="buyList?'عنوان شرکت':'عنوان فروشگاه'">
                <template v-slot:prepend>
                  <q-icon name="person"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Cs_Address1"
                  :label="buyList?'آدرس شرکت':'آدرس فروشگاه'"
                  :rules="[ val => val && val.length > 0 || 'آدرس اول الزامی است']">
                <template v-slot:prepend>
                  <q-icon name="location_on"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Cs_Address2"
                  :label="buyList?'آدرس شرکت':'آدرس فروشگاه'">
                <template v-slot:prepend>
                  <q-icon name="location_on"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  type="number"
                  v-model="customerInfo.Cs_MelliCode"
                  mask="##########"
                  hint="##########"
                  label="کد ملی">
                <template v-slot:prepend>
                  <q-icon name="local_phone"/>
                </template>
              </q-input>

              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  type="number"
                  v-model="customerInfo.Cs_ZipCode"
                  mask="##########"
                  hint="##########"
                  label="کد پستی">
                <template v-slot:prepend>
                  <q-icon name="local_phone"/>
                </template>
              </q-input>
            </q-tab-panel>
            <q-tab-panel name="phone" style="height: 400px">
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  v-model="customerInfo.Cs_Tel1"
                  type="tel"
                  mask="(###) ########"
                  hint="قالب ورود اطلاعات: ######## (###)"
                  label="تلفن">
                <template v-slot:prepend>
                  <q-icon name="local_phone"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  type="tel"
                  v-model="customerInfo.Cs_Tel2"
                  mask="(###) ########"
                  hint="قالب ورود اطلاعات: ######## (###)"
                  label="تلفن">
                <template v-slot:prepend>
                  <q-icon name="local_phone"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  v-model="customerInfo.Cs_Mobile"
                  mask="(####) (###) (####)"
                  type="tel"
                  hint="قالب ورود اطلاعات: (####) (###) (####)"
                  :rules="[ val => val.toString().replaceAll(' ','').replaceAll('(','').replaceAll(')','').length >= 11 || 'شماره موبایل الزامی است']"
                  label="موبایل">
                <template v-slot:prepend>
                  <q-icon name="phone_android"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  v-model="customerInfo.Cs_Mobile2"
                  mask="(####) (###) (####)"
                  type="tel"
                  hint="قالب ورود اطلاعات: (####) (###) (####)"
                  label="موبایل">
                <template v-slot:prepend>
                  <q-icon name="phone_android"/>
                </template>
              </q-input>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  hide-bottom-space
                  dir="ltr"
                  type="tel"
                  v-model="customerInfo.Cs_Fax"
                  mask="(###) ########"
                  hint="قالب ورود اطلاعات: ######## (###)"
                  label="فکس">
                <template v-slot:prepend>
                  <q-icon name="local_phone"/>
                </template>
              </q-input>
            </q-tab-panel>
            <q-tab-panel name="comment" style="height: 400px">
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  hide-bottom-space
                  v-model="customerInfo.Presenter_ID"
                  use-input
                  input-debounce="0"
                  label="معرف"
                  :options="presentersListOptions"
                  behavior="dialog"
                  option-label="UserName"
                  option-value="Users_ID"
                  emit-value
                  map-options
                  @filter="presenterFilterFn"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-input
                  :dense="$q.screen.lt.md"
                  class="q-ma-sm"
                  filled
                  maxlength="4000"
                  hide-bottom-space
                  v-model="customerInfo.Cs_Desc"
                  type="textarea"
                  label="شرح مختصر">
              </q-input>
            </q-tab-panel>
            <q-tab-panel name="tags" style="height: 400px">
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  use-chips
                  hide-bottom-space
                  v-model="customerInfo.tags"
                  use-input
                  label="برچسب ها"
                  :options="filterTagsOptions"
                  multiple
                  @new-value="createTag"
                  @filter="filterTagFn"
              />
            </q-tab-panel>
          </q-tab-panels>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn :label="action==='edit'?'تایید':'تایید'" type="submit"
                 class="bg-indigo-6 text-white" :icon="action==='edit'?'edit':'add'"/>
          <q-btn label="انصراف" flat class="q-ml-sm" icon="cancel" color="red" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-form>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showEventDialog">
      <q-card>
        <q-card-section>
          <CUVisitLog @event-added="closeEventDialog" :selected-customer="customerInsertedInfo"/>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>

</template>

<script>
import {mapActions} from "vuex";
import CUVisitLog from "@/components/customers/CUVisitLog";

export default {
  name: "CUCustomerInfo",
  components: {CUVisitLog},
  props: {
    action: {
      type: String
    },
    selectedCustomerInfo: {
      type: Object
    },
    buyList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Customer_Rate: 0,
      customerInfo: '',
      showEventDialog: false,
      prefixes: [
        {id: 1, label: 'آقا'},
        {id: 2, label: 'خانم'},
        {id: 3, label: 'شرکت'}
      ],
      newCustomer: {
        prefix: undefined,
        Archived: false,
        defaultStore: '',
        Cs_ID: '',
        Cs_Code: '',
        Cs_Name: '',
        Cs_Address1: '',
        Cs_Address2: '',
        Cs_Tel1: '',
        Cs_Tel2: '',
        Cs_Mobile: '',
        Cs_Fax: '',
        Cs_Presenter: '',
        CSKind_ID: '',
        Cs_Desc: '',
        Cs_FirPay: '',
        Cs_Pay: '',
        Cs_Visitor_ID: '',
        Cs_Begin: '',
        CsZone_ID: '',
        Cs_Del: '',
        Cs_DelUsersID: '',
        Cs_DelDateTime: '',
        Cs_Economic: '',
        Cs_Tmp01: '',
        Cs_Tmp02: '',
        CsState_ID: '',
        CsCity_ID: '',
        Cs_FirName: '',
        Cs_FamName: '',
        CsLab_ID: '',
        CsSpe_ID: -1,
        Cs_EtehadiePrice: '',
        Cs_CompanyID: '',
        Cs_TelCode: '',
        Cs_Select: '',
        Cs_Tmp03: '',
        Cs_ZipCode: '',
        Cs_TransportName: '',
        Cs_PrintPay: '',
        Cs_SaleStatus: '',
        Cs_AccTaf_ID: '',
        Cs_PrintSaleOff: '',
        Cs_BDRial: '',
        Cs_BDChek: '',
        Cs_Mobile2: '',
        latitude: '',
        longitude: '',
        accuracy: '',
        Customer_Rate: 0,
        Cs_ShopName: undefined,
        Cs_MelliCode: undefined,
        Presenter_ID: undefined,
        tags: []
      },
      cities: [],
      cityList: [],
      stateList: [],
      stateListOptions: [],
      customerKind: [],
      customerKindOptions: [],
      companyList: [],
      companyListOptions: [],
      options: [],
      storeList: [],
      filterTagsOptions: undefined,
      tags: [],
      tab: 'select',
      customerInsertedInfo: '',
      customerSpec: [],
      customerSpecOptions: [],
      presentersList: [],
      presentersListOptions: [],
      zones: [],
      zonesOptions: []
    }
  },
  methods: {
    ...mapActions({
      UpdateCustomerInfo: 'Customers/setCustomerInfo',
      InsertCustomer: 'Customers/insertCustomerInfo',
      getCustomerCityKind: 'Customers/get_customer_city_kind',
      getCustomerInfo: 'Customers/get_customer_info',
      getUsers: 'Users/getUsers',
      createCustomerTag: 'Customers/createCustomerTags',
      getCustomerTags: 'Customers/getCustomerTags',
      updateCustomerTags: 'Customers/updateTags'
    }),
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    onSubmit() {
      if (!this.$store.state.roles.some(v => ['admin', 'can_change_of_nature'].includes(v))) {
        this.customerInfo.CsSpe_ID = this.buyList ? this.customerSpec.filter(item => item.CSKind_ID === 1)[0] : this.customerSpec.filter(item => item.CSKind_ID === 2)[0];
      }

      if (this.customerInfo.Cs_FamName === null || this.customerInfo.Cs_FamName === undefined || this.customerInfo.Cs_FamName === '') {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'نام و نام حانوادگی طرف معامل را وارد نمایید'
        })
        return;
      }
      if (this.customerInfo.Cs_CompanyID === null || this.customerInfo.Cs_CompanyID === undefined || this.customerInfo.Cs_CompanyID === '') {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'شرکت پشتیبان کننده طرف معامل را وارد نمایید'
        })
        return;
      }
      if (this.customerInfo.CsCity_ID === '' || this.customerInfo.CsCity_ID === null || this.customerInfo.CsCity_ID === undefined) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'شهری که فروشگاه/شرکت طرف معامل در آن واقع شده است را وارد کنید'
        })
        return;
      }
      if (this.customerInfo.defaultStore === '' || this.customerInfo.defaultStore === null || this.customerInfo.defaultStore === undefined) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'انبار پیش فرض طرف معامل را انتخاب کنید'
        })
        return;
      }
      if (this.customerInfo.Cs_Mobile === '' || this.customerInfo.Cs_Mobile === null || this.customerInfo.Cs_Mobile === undefined) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'موبایل طرف معامل را وارد کنید'
        })
        return;
      }
      if (this.customerInfo.Cs_Address1 === '' || this.customerInfo.Cs_Address1 === null || this.customerInfo.Cs_Address1 === undefined) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'آدرس طرف معامل را وارد کنید'
        })
        return;
      }
      if (!this.customerInfo.CsZone_ID) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'انتخاب منطقه الزامی است'
        })
        return;
      }
      if (!this.customerInfo.prefix) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'پیش عنوان را انتخاب نمایید'
        })
        return;
      }
      if (this.action === 'edit') {
        this.UpdateCustomerInfo(this.customerInfo).then((res) => {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            message: 'اطلاعات طرف معامل به روز رسانی گردید'
          });
          this.customerInfo.CsCity_ID = res.data[0].CsCity_ID;
          this.customerInfo.CSKind_ID = res.data[0].CSKind_ID;
          this.$emit('customer-updated', res.data);
        }).catch((err) => {
          if (err.toString().includes('409')) {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              message: 'اطلاعات طرف معامل تکراری است'
            });
          } else {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              message: 'امکان به روز اطلاعات طرف معامل میسر نمی باشد'
            });
          }
        });
      } else {
        this.InsertCustomer(this.customerInfo).then((res) => {
          if (res.data.message) {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              message: res.data.message
            });
          } else {
            this.$q.notify({
              type: 'positive',
              color: 'positive',
              position: 'top',
              message: 'اطلاعات طرف معامل ثبت گردید'
            });
            this.customerInsertedInfo = res.data[0];
            this.addComment()
          }
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position: 'top',
            message: 'امکان ثبت طرف معامل میسر نمی باشد'
          });
        });
      }
    },
    addComment() {
      this.$q.dialog({
        title: 'می خواهید برای طرف معامل گزارشی ثبت نمایید؟',
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'red',
          flat: true
        },
        persistent: true,
      }).onOk(() => {
        this.showEventDialog = true
      }).onCancel(() => {
        this.$emit('customer-updated', this.customerInsertedInfo);
      }).onDismiss(() => {
      })
    },
    closeEventDialog() {
      this.showEventDialog = false
      this.$emit('customer-updated', this.customerInsertedInfo);
    },
    stateFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.options = []
        })
        return
      }
      update(() => {
        this.stateListOptions = this.stateList.filter(v => v.State_Name.toLowerCase().indexOf(val) > -1)
      })
    },
    presenterFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.presentersListOptions = this.presentersList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.presentersListOptions = this.presentersList.filter(v => v.UserName.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFn(val, update) {
      if (val === '') {
        update(() => {
          this.options = this.cityList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.options = this.cityList.filter(v => v.City_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFnZone(val, update) {
      if (val === '') {
        update(() => {
          this.zonesOptions = this.zones
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.zonesOptions = this.zones.filter(v => v.Zone_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFnKind(val, update) {
      if (val === '') {
        update(() => {
          this.customerKindOptions = this.customerKind
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.customerKindOptions = this.customerKind.filter(v => v.CSKind_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFnCompany(val, update) {
      if (val === '') {
        update(() => {
          this.companyListOptions = this.companyList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.companyListOptions = this.companyList.filter(v => v.CompName.toLowerCase().indexOf(needle) > -1)
      })
    },
    createTag(val, done) {
      if (val.length > 0) {
        done(val, 'add-unique')
      }
    },
    filterTagFn(val, update) {
      update(() => {
        if (val === '') {
          this.filterTagsOptions = this.tags
        } else {
          if (val.length <= 3) return
          const needle = val.toLowerCase()
          this.filterTagsOptions = this.tags.filter(
              v => v.toLowerCase().indexOf(needle) > -1
          )
        }
      })
    }
  },
  watch: {
    'customerInfo.tags': function (newValue) {
      if (newValue && newValue.length > 0) {
        this.updateCustomerTags({
          customerId: this.customerInfo.Cs_ID,
          tagsInfo: newValue
        }).then(() => {
        })
      }
    },
    Customer_Rate: function (newValue) {
      this.customerInfo.Customer_Rate = newValue;
    },
    'newCustomer.CsState_ID': function (newValue) {
      if (newValue) {
        this.cityList = this.cities.filter(v => v.State_ID === newValue.State_ID)
        this.options = this.cityList;
      }
    },
    'customerInfo.CsState_ID': function (newValue) {
      if (newValue) {
        this.cityList = this.cities.filter(v => v.State_ID === newValue.State_ID)
        this.options = this.cityList;
      }
    }
  },
  created() {
    this.getUsers().then((res) => {
      this.presentersList = res
      this.presentersListOptions = this.presentersList
    })
    this.getCustomerCityKind().then((res) => {
      this.filterTagsOptions = JSON.parse(res.data.customerTags).map(item => item.TagName)
      this.tags = this.filterTagsOptions
      this.cities = JSON.parse(res.data.customer_city);
      this.cityList = this.cities
      this.zones = JSON.parse(res.data.zones)
      this.zonesOptions = this.zones
      this.customerKind = JSON.parse(res.data.customer_kind).filter(item => item.CsKind_Leg === 2);
      this.customerSpec = JSON.parse(res.data.customer_kind).filter(item => item.CsKind_Leg === 1);
      this.customerSpecOptions = this.customerSpec
      this.companyList = JSON.parse(res.data.company_list);
      this.stateList = JSON.parse(res.data.customer_state);
      this.stateListOptions = this.stateList;
      this.customerKindOptions = this.customerKind;
      this.companyListOptions = this.companyList;
      this.storeList = JSON.parse(res.data.storeList);
      if (this.action === 'edit') {
        this.getCustomerInfo(this.selectedCustomerInfo.Cs_ID).then((res) => {
          this.customerInfo = res.data[0]
          if (JSON.parse(res.data[0].tags)) {
            this.customerInfo.tags = JSON.parse(res.data[0].tags).map(rec => rec.TagName)
          } else {
            this.customerInfo.tags = []
          }

          this.customerInfo.CsCity_ID = this.cityList.filter(item => item.City_ID === this.customerInfo.CsCity_ID)[0]
          this.customerInfo.Cs_CompanyID = this.companyList.filter(item => item.CompID === this.customerInfo.Cs_CompanyID)[0]
          this.customerInfo.CsState_ID = this.stateList.filter(item => item.State_ID === this.customerInfo.CsState_ID)[0]
          this.customerInfo.CsZone_ID = this.zones.filter(item => item.Zone_ID === this.customerInfo.CsZone_ID)[0]
          this.customerInfo.prefix = this.prefixes.filter(item => item.label === this.customerInfo.prefix)[0]
          if (this.customerInfo.CSKind_ID !== null && this.customerInfo.CSKind_ID !== '') {
            this.customerInfo.CSKind_ID = this.customerKind.filter(item => item.CSKind_ID === this.customerInfo.CSKind_ID)[0]
          }
          if (this.customerInfo.CsSpe_ID !== null && this.customerInfo.CsSpe_ID !== '') {
            this.customerInfo.CsSpe_ID = this.customerSpecOptions.filter(item => item.CSKind_ID === this.customerInfo.CsSpe_ID)[0]
          }
          if (this.selectedCustomerInfo.Cs_StorID !== null) {
            this.customerInfo.defaultStore = this.storeList.filter(item => item.StorID === this.selectedCustomerInfo.Cs_StorID)[0]
          }
          this.Customer_Rate = parseFloat(this.customerInfo.Customer_Rate)
        })

      } else {
        this.customerInfo = this.newCustomer;
      }
    });
  }
}
</script>

<style scoped>

</style>
